import type { ReactNode } from 'react';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import { voltAiBot } from '@/assets/images/chat';
import { externalUrls } from '@/constants/urls';
import styles from './VoltAppBanner.module.scss';

interface VoltAppBannerProps {
  title: ReactNode;
  trackingId: string;
}

export function VoltAppBanner({ title, trackingId }: VoltAppBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.icon}>
        <img src={voltAiBot} alt="" width={54} height={54} />
      </div>
      <div className={styles.text}>
        <p className={styles.title}>{title}</p>
        <Button
          trackingId={trackingId}
          variant="text"
          size="xsmall"
          text="Descarcă Volt"
          rightIcon={<Icon name="arrow-right" />}
          onClick={() => {
            window.location.href = externalUrls.volt.appDownload;
          }}
          className={styles.button}
        />
      </div>
    </div>
  );
}
